import React, { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon, Menu, Position } from '@blueprintjs/core';
import { Popover2 } from "@blueprintjs/popover2";
import { IconNames } from '@blueprintjs/icons';
import { Link, useHistory } from 'react-router-dom';

import { IState } from '../../store/reducers';
import { switchWorkspace } from '../../store/actions/workspaceActions';
import { WorkspaceMenuItemElements } from '../layout/Header/WorkspaceMenu';

import './NotFoundPage.scss';

declare var Intercom: any;

interface INotFoundPage {}

export const NotFoundPage: FunctionComponent<INotFoundPage> = ({}: INotFoundPage) => {
  const history: any = useHistory();
  const dispatch = useDispatch();
  const workspaces = useSelector((state: IState) => state.workspaces.workspaces);

  const onChangeWorkspace = (workspaceUid: string) => {
    dispatch(switchWorkspace(workspaceUid, { goto: history.location.state?.pathname, toaster: true }));
  };

  return (
    <div className="not-found">
      <div className="not-found__content">
        <h1>404</h1>
        <h2><Icon icon={IconNames.WARNING_SIGN} size={22} />Page Not Found</h2>
        <p>Sorry, the page you requested does not exist or<br/>
        you don't have access to it.</p>
        <p>
          <Link to="/app"><Icon icon={IconNames.ARROW_RIGHT} size={10} />Go to Home tab</Link><br/>
          <span className="not-found__chat" onClick={() => {
            Intercom('show');
          }}><Icon icon={IconNames.ARROW_RIGHT} size={10} />Contact Support</span>
        </p>
        <RenderWorkspace
          workspaces={workspaces}
          onChangeWorkspace={onChangeWorkspace} />
      </div>
    </div>
  );
}

const RenderWorkspace = ({
  workspaces,
  onChangeWorkspace
}: any) => {
  const multipleWorkspace = workspaces?.length > 1 || false;

  if (!multipleWorkspace) {
    return null;
  }

  const menuContent = (
    <Menu>
      <WorkspaceMenuItemElements
        workspaces={workspaces}
        onChangeWorkspace={onChangeWorkspace} />
    </Menu>
  );

  return (
    <>
      <Popover2
        content={menuContent}
        position={Position.BOTTOM_LEFT}>
        <Button
          minimal={true}
          text="Try in a different workspace"
          rightIcon={IconNames.CARET_DOWN}
        />
      </Popover2>
    </>
  );
}
